const API_BASE_URL: string = import.meta.env.VITE_API_URL || "";

function withBase(path: string): string {
  return `${API_BASE_URL.replace(/\/$/, "")}${path}`;
}

export interface SchoolNoteEntry {
  _id: string;
  teamId: string;
  schoolName: string;
  notes: string;
  createdAt: string;
  updatedAt: string;
}

export async function fetchSchoolNotes(params?: {
  linkedJgsProfile?: string;
}): Promise<{ notes: SchoolNoteEntry[] }> {
  const url = new URL(withBase("/school-notes"));
  if (params?.linkedJgsProfile) url.searchParams.set("linkedJgsProfile", params.linkedJgsProfile);

  const resp = await fetch(url.toString(), {
    method: "GET",
    credentials: "include",
  });

  if (!resp.ok) {
    const t = await resp.text().catch(() => "");
    throw new Error(t || `Failed to fetch school notes (${resp.status})`);
  }

  return resp.json();
}

export async function upsertSchoolNote(
  teamId: string,
  notes: string,
  schoolName: string,
  linkedJgsProfile?: string
): Promise<void> {
  const url = new URL(withBase(`/school-notes/${encodeURIComponent(teamId)}`));
  if (linkedJgsProfile) url.searchParams.set("linkedJgsProfile", linkedJgsProfile);

  const resp = await fetch(url.toString(), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ notes, schoolName }),
  });

  if (!resp.ok) {
    const t = await resp.text().catch(() => "");
    throw new Error(t || `Failed to save school note (${resp.status})`);
  }
}
